import React from 'react';
import dayjs from 'dayjs';
import Typography from '@mui/material/Typography';

import type { IShowing } from 'src/api/landlord-showings-api';
import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import Tour from 'src/components/lead-sidebar/LeadSidebarTour';

interface Props {
    lead: ILead,
    showings: IShowing[],
}

export default function LeadSidebarUpcomingTour({
    lead,
    showings,
}: Props) {
    const upcomingTours = showings.filter((showing) => {
        return showing.lead_uuid === lead.uuid && !dayjs(showing.start_time).isBefore(dayjs());
    });

    const upcomingTour = upcomingTours[0];

    return (
        <ExpandableItem title="Upcoming Tour" defaultExpanded={!!upcomingTour}>
            {upcomingTour ? (
                <Tour
                    lead={lead}
                    showing={upcomingTour}
                    color="var(--primary-color)"
                />
            ) : (
                <Typography variant="body2" color="grey">No Upcoming tours</Typography>
            )}
        </ExpandableItem>
    );
}
